// Cycle through each science icon cluster independently
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.science-cycle').forEach(function (container, groupIdx) {
    var frames = Array.from(container.querySelectorAll('.icon-frame'));
    if (!frames.length) return;
    var frameIdx = 0;
    setInterval(function () {
      frames[frameIdx].classList.remove('active');
      frameIdx = (frameIdx + 1) % frames.length;
      frames[frameIdx].classList.add('active');
    }, 2600 + groupIdx * 500);
  });

  // Scroll reveal
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('in');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  document.querySelectorAll('.reveal').forEach(function (el) { observer.observe(el); });

  // Safety net: some mobile browsers can be inconsistent with IntersectionObserver timing.
  // Whatever happens, make sure nothing stays invisible forever.
  setTimeout(function () {
    document.querySelectorAll('.reveal:not(.in)').forEach(function (el) {
      el.classList.add('in');
    });
  }, 2500);

  // Product card 3D tilt (if present)
  document.querySelectorAll('[data-tilt]').forEach(function (card) {
    var inner = card.querySelector('.tilt-inner');
    if (!inner) return;
    card.addEventListener('mousemove', function (e) {
      var r = card.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      inner.style.transform = 'rotateY(' + (x * 8) + 'deg) rotateX(' + (-y * 8) + 'deg) translateZ(4px)';
    });
    card.addEventListener('mouseleave', function () {
      inner.style.transform = 'rotateY(0) rotateX(0) translateZ(0)';
    });
  });

  // Site-wide AJAX add-to-cart: stay on the page, just update the cart icon count.
  // The cart page itself only opens when someone actually clicks the cart icon.
  // Listening on click (not just submit) because add-to-cart buttons can sit inside
  // a card that's itself wrapped in a link (e.g. product grid cards) - if we only
  // stopped the submit event, the click would still bubble up and trigger that
  // outer link's navigation before the form ever got to submit.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[type="submit"]');
    if (!btn) return;
    var form = btn.closest('form');
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;

    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form)
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        return fetch('/cart.js');
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var countEls = document.querySelectorAll('[data-cart-count]');
        countEls.forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
        showAddedToast();
        btn.disabled = false;
      })
      .catch(function () {
        btn.disabled = false;
      });
  }, true);

  function showAddedToast() {
    var existing = document.querySelector('[data-cart-toast]');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.setAttribute('data-cart-toast', '');
    toast.textContent = 'Added to cart';
    toast.style.cssText =
      'position:fixed; bottom:24px; right:24px; z-index:9999; background:var(--ink); color:#fff; ' +
      'font-family:var(--body); font-size:14px; font-weight:600; padding:14px 22px; border-radius:100px; ' +
      'box-shadow:0 20px 40px -12px rgba(0,0,0,0.35); opacity:0; transform:translateY(8px); ' +
      'transition:opacity .3s ease, transform .3s ease;';
    document.body.appendChild(toast);
    requestAnimationFrame(function () {
      toast.style.opacity = '1';
      toast.style.transform = 'translateY(0)';
    });
    setTimeout(function () {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(8px)';
      setTimeout(function () { toast.remove(); }, 300);
    }, 2200);
  }
});
